import React, { useEffect, useState } from 'react'
import Input from "../../../../../../core/Inputs/DefaultInput";

const CustomInputPreview = ({ language_code, data, index: idx }) => {


    //==> STATES <==
    const [type, setType] = useState(null)
    const [label, setLabel] = useState(null)
    const [name, setName] = useState(null)
    const [options, setOptions] = useState(null)
    const [id, setId] = useState(null)
    const [isRequired, setIsRequired] = useState(false)


    //==> EFFECTS <==
    useEffect(() => {
        if (data) {
            const tmpType = data.su_form_variable_type
            const tmpLabel = data.su_label_and_options && JSON.parse(data.su_label_and_options)[language_code]
            const tmpName = data.su_name
            const tmpOptions = data.su_options && JSON.parse(data.su_options)
            const tmpId = data.su_lead_gen_variable_id

            setLabel(tmpLabel)
            setName(tmpName)
            setOptions(tmpOptions)
            setType(tmpType)
            setId(tmpId)

            if (tmpOptions && tmpType) {
                if (tmpType === 1) {
                    const tmpAttributes = tmpOptions['0']
                    if (tmpAttributes.type === 'text' || tmpAttributes.type === 'number' || tmpAttributes.type === 'email') {
                        setIsRequired(tmpAttributes?.required ? true : false)
                    } else if (tmpAttributes.type === 'checkbox' || tmpAttributes.type === 'radio') {
                        setIsRequired(tmpAttributes?.required ? true : false)
                    }
                } else if (tmpType === 3) {
                    setIsRequired(tmpOptions.required ? true : false)
                } else if (tmpType === 4) {
                    setIsRequired(tmpOptions.required ? true : false)
                }
            }
        }
    }, [data, language_code])

    const canEditFields = window.modulePermissions.M12.edit == 1

    if (type === 1) {
        const tmpAttributes = options['0']
        if (tmpAttributes.type === 'text' || tmpAttributes.type === 'number' || tmpAttributes.type === 'email') {
            return (
                <div className="mb__30">
                    <label className='form-label-custom'>{label}</label>
                    <Input
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder='Business email'
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        name={name}
                        {...tmpAttributes}
                        readOnly={!canEditFields}
                    />
                </div>
            )
        } else if (tmpAttributes.type === 'checkbox' || tmpAttributes.type === 'radio') {
            return (
                <div className="mb__30">
                    <label className='form-label-custom'>{label}</label>
                    <div className='radio-group'>
                        {options && Object.keys(options)?.map((key, index) => {
                            const attributes = options[key]
                            const { disabled: _ignoreDisabled, ...checkboxProps } = attributes
                            return (
                                <div className="form-check form-check-inline ps-0" key={index}>
                                    <input className="form-check-input" name={name} id={`${tmpAttributes.type}-group${idx}_${index}`} {...checkboxProps} disabled={!canEditFields} />
                                    <label className="form-check-label" htmlFor={`${tmpAttributes.type}-group${idx}_${index}`}>{attributes.value}</label>
                                </div>
                            )
                        })}
                    </div>
                </div>
            )
        } else {
            return (
                <div className="mb__30">
                    <label className='form-label-custom'>{label}</label>
                    <Input
                        view='outlined'
                        dense={false}
                        color='default'
                        label=''
                        placeholder='Business email'
                        success={false}
                        error={false}
                        fill={true}
                        errorHelperText={null}
                        className={"formsinput"}
                        name={name}
                        {...tmpAttributes}
                        readOnly={!canEditFields}
                    />
                </div>
            )
        }
    } else if (type === 3) {
        const { option, placeholder } = options
        return (
            <div className="mb__30">
                <label className='form-label-custom'>{label}</label>
                <select className="form-control" name={name} disabled={!canEditFields}>
                    <option value={null}>{placeholder ?? 'Select'}</option>
                    {
                        Object.keys(option)?.map((item, index) => {
                            return (
                                <option key={index} value={item}>{option[item]}</option>
                            )
                        })
                    }
                </select>
            </div>
        )
    } else if (type === 4) {
        const attributes = options
        return (
            <div className="mb__30">
                <label className='form-label-custom'>{label}</label>
                <textarea className="form-control" id="exampleFormControlTextarea1"  {...attributes} readOnly={!canEditFields} />
            </div>
        )
    } else if (type === 6) {
        return (
            <div className="mb__30">
                <div dangerouslySetInnerHTML={{ __html: label || '' }} />
            </div>
        )
    } else {
        return ('')
    }
}

export default CustomInputPreview